import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

import { Layout } from '../../../navigation/components/Layout/Layout';
import { UserInfosRequiredCard } from '../../../user/components/UserInfosRequiredCard';
import { useCurrentUserQuery } from '../../../user/hooks/useCurrentUserQuery';
import { HeaderCard } from '../../components/HeaderCard';
import { useCurrentEventQuery } from '../../hooks/useCurrentEventQuery';

export const Caution: FunctionComponent = () => {
  const navigate = useNavigate();
  const { data, loading } = useCurrentEventQuery();
  const { data: currentUserData } = useCurrentUserQuery();

  const currentEvent = data?.currentEvent ?? null;
  const currentUser = currentUserData?.currentUser;
  const hasGivenInformation =
    currentUser?.firstname && currentUser?.lastname && currentUser?.birthdate;

  const onGoToDashboard = () => {
    navigate('/dashboard');
  };

  const onGoToEventRegister = () => {
    navigate('/event-register');
  };

  return (
    <Layout title="Chèque de caution" activeTab="caution">
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <HeaderCard />
          {hasGivenInformation ? (
            currentEvent ? (
              <Card>
                {!currentEvent.hasJoined ? (
                  <CardContent>
                    <Typography variant="body2">
                      {`Vous n'avez pas encore rejoint l'événement. Veuillez vous inscrire avant de vous préoccuper de la caution`}
                    </Typography>
                  </CardContent>
                ) : currentEvent.hasCaution ? (
                  <CardContent>
                    <Typography variant="body2">
                      {'Nous avons bien reçu vos chèques de caution'}
                    </Typography>
                  </CardContent>
                ) : (
                  <CardContent>
                    <Typography variant="h6">
                      {"Nous n'avons pas encore reçu vos chèques de caution"}
                    </Typography>
                    <Typography variant="body1">
                      {`Nous avons besoin d'un chèque de 133€ de caution, ainsi que d'un autre chèque de caution écologique de 10€. Ils doivent être à l'ordre de "La Flute"`}
                    </Typography>
                    <Typography variant="body1">
                      {"Envoyez vos chèques de caution à l'adresse suivante :"}
                    </Typography>

                    {currentEvent.checkAddress.split('\n').map((line) => (
                      <Typography variant="body2" key={line}>
                        {line}
                      </Typography>
                    ))}
                    <Typography variant="body1">
                      {
                        "Vous pouvez aussi les transmettre directement à l'organisation si vous en avez la possibilité"
                      }
                    </Typography>
                  </CardContent>
                )}
                {currentEvent.hasJoined ? (
                  <CardActions>
                    <Button variant="contained" onClick={onGoToDashboard}>
                      Retourner au Dashboard
                    </Button>
                  </CardActions>
                ) : (
                  <CardActions>
                    <Button variant="contained" onClick={onGoToEventRegister}>
                      {`S'inscrire`}
                    </Button>
                  </CardActions>
                )}
              </Card>
            ) : null
          ) : (
            <UserInfosRequiredCard />
          )}
        </>
      )}
    </Layout>
  );
};
